import { ComponentProps, FC } from 'react';
import cn from 'classnames';
import { createBemBlockBuilder, Modal as EbscoModal } from '@ebsco-ui/ebsco-ui';

import { IS_TEST_ENV, MODAL_PLACEMENT } from '@app/constants';

const cnBemModal = createBemBlockBuilder(['modal']);

interface ModalProps extends ComponentProps<typeof EbscoModal> {
  shouldIncludeModalStyles?: boolean;
}

interface ModalComposite extends FC<ModalProps> {
  Body: typeof EbscoModal.Body;
  Footer: typeof EbscoModal.Footer;
}

export const Modal: ModalComposite = ({
  isOpen,
  className,
  modalTitle,
  shouldIncludeModalStyles = true,
  children,
  onClose,
  ...props
}) => {
  return (
    <EbscoModal
      isOpen={isOpen}
      className={cn(className, {
        [cnBemModal()]: shouldIncludeModalStyles,
      })}
      modalTitle={modalTitle}
      appElement={MODAL_PLACEMENT}
      ariaHideApp={!IS_TEST_ENV}
      disableAnimations={IS_TEST_ENV}
      onClose={onClose}
      {...props}
    >
      {children}
    </EbscoModal>
  );
};

Modal.Body = EbscoModal.Body;
Modal.Footer = EbscoModal.Footer;
